import Delete from "@mui/icons-material/Delete";
import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import { CoAppDataGridActionsContainer } from "../../../../global/styled/global.styled";

export const roleIdpGroupColumns = ["actions", "name", "createdAt"];

export interface RoleIdpGroupRow {
	id: string | number;
	name: string;
	createdAt?: string | null;
	[key: string]: unknown;
}

export const getRoleSSOColumns = (
	identityProviderName: string | null,
	removeIdPGroupFromRole: (idpGroupId: RoleIdpGroupRow["id"]) => void
): GridColDef<RoleIdpGroupRow>[] => [
	{
		field: "name",
		headerName: identityProviderName ? `${identityProviderName} Group` : "Group",
		disableExport: true,
		sortable: true,
		editable: true,
		flex: 1,
		renderCell: (params: GridRenderCellParams<RoleIdpGroupRow>) => (
			<CoAppDataGridNameCell item={params.row} />
		),
	},
	{
		field: "createdAt",
		headerName: "Date Mapped",
		disableExport: true,
		sortable: true,
		editable: true,
		flex: 1,
		valueGetter: (value) => {
			if (!value) {
				return null;
			}
			return new Date(value as string);
		},
		renderCell: (params: GridRenderCellParams<RoleIdpGroupRow, Date | null>) => (
			<CoAppDataGridDateTimeCell value={params.value} />
		),
	},
	{
		field: "actions",
		disableExport: true,
		sortable: false,
		type: "actions",
		flex: .1,
		renderCell: (params: GridRenderCellParams<RoleIdpGroupRow>) => (
			<CoAppDataGridActionsContainer>
						<Delete
							onClick={() => {
								removeIdPGroupFromRole(params.row.id);
							}}
						/>
					</CoAppDataGridActionsContainer>
		),
	},
];
